export default __webpack_public_path__ + "static/media/loading.db10c6c6.gif";